var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayNotification)?_c('notification',{attrs:{"message":_vm.notificationMessage,"type":_vm.notificationType}}):_vm._e(),_vm._v(" "),_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }